// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JjSCzj5eyxwawOQe8Net{flex-direction:column;width:100%;max-width:772px;display:flex;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `JjSCzj5eyxwawOQe8Net`
};
export default ___CSS_LOADER_EXPORT___;
